import axios from 'axios';
import axiosInstance from '../../../_utils/axiosConfig';

let Location : any = {};

Location.submitForm = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/location/add`, data)
}

Location.verifyLocationForm = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/location/verify`,data)
}

Location.submitFormPopUp = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/location/voititure/update/popup`, data)
}

Location.getHomeData = async (code:string) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/location/home/${code}`)
}

Location.getAllData = async (code:string) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/location/all/${code}`)
}

Location.submitReservation = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/location/send/reservation`, data)
}

Location.submitEdit = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/location/edit`, data)
}

Location.getOne = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/location/show/${id}`)
}

Location.getImages = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/location/images/${id}`)
}

Location.getBrand = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/brand/all/${id}`)
}

Location.saveLike = async (data:any)=>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/save/like`,data)
}

Location.deletLike = async (id:any,idAnnonce:any)=>{
    return await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/delete/like/${id}/${idAnnonce}`)
}

Location.saveComment = async(data:any)=>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/save/comment`,data)
}

Location.getAllComment = async (id:any)=>{
     return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/get/all/${id}`)
}
export default Location;